window.addEventListener("turbolinks:load", () => {
  $(".modal-auto-display").each((i, el) => { new bootstrap.Modal(el).show() })
})
